import { fromNavigationComponents } from 'pharmacy/src/contexts/navigation'

export default fromNavigationComponents('QuestionLinkComponent')
